var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CollectionList',{staticClass:"m-b-10"}),_c('FileCenter',{staticClass:"m-b-10 min-height-300"},[_c('h3',{staticClass:"m-v-0",attrs:{"slot":"title"},slot:"title"},[_vm._v("部门文件共享")])])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11e1454e","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/Dashboard.vue
// module id = null
// module chunks = 